<template>
  <div
    class="sidearm-mm-player-card fixed  flex flex-column"
    :class="{ 'is-toggled': value }"
    v-dom-portal
    scrolling
  >
    <div class="flex-item-auto">
      <div class="col-7-of-8 text-right">
        <button
          @click="close"
          type="button"
          class="sidearm-mm-player-card__close-btn"
        >
          <span>Close</span>
          <icon size="1.625rem">sf-close-minimal</icon>
        </button>
      </div>
    </div>

    <div
      v-if="player && player.cumestats"
      class="sidearm-mm-player-card__container relative bg-white flex flex-align-center"
    >
      <div
        class="sidearm-mm-player-card__container-inner relative  w-100 minh-100"
      >
        <div class="sidearm-mm-player-card__background overflow-hidden">
          <img
            class="sidearm-mm-player-card__background-blur absolute"
            src="~@/assets/themes/cinderella/glass-blur-top.png"
          />
        </div>
        <div class="sidearm-mm-player-card__player-container">
          <h3
            class="my-0 mx-4 type-hero sidearm-mm-player-card__player-container-title"
          >
            {{
              player.name
                ? player.name
                : player.first_name + " " + player.last_name
            }}
          </h3>
          <img
            v-if="player.cutout_image && player.cutout_image.url"
            :src="
              `${$root.absolutize_cdn(
                player.cutout_image.url
              )}?width=720&height=960`
            "
            :alt="player.name"
            class="sidearm-mm-player-card__player-cutout w-auto h-auto"
          />
        </div>

        <div
          class="sidearm-mm-player-card__stat-content relative flex flex-column flex-align-start flex-justify-start"
        >
          <h3
            class="mt-4 mb-4 type-hero sidearm-mm-player-card__stat-content-title"
          >
            {{
              player.name
                ? player.name
                : player.first_name + " " + player.last_name
            }}
          </h3>
          <div class="sidearm-mm-player-card__stat-sheet w-100 bg-white">
            <div class="flex flex-align-stretch flex-wrap border-light-b">
              <div
                class="sidearm-mm-player-card__about flex flex-column flex-aligns-stretch"
              >
                <div
                  v-if="player.height_feet"
                  class="sidearm-mm-player-card__about-stat flex flex-justify-between flex-align-center px-1"
                >
                  <div class="px-1">Height:</div>
                  <div class="px-1">
                    {{ player.height_feet + '" ' + player.height_inches + "'" }}
                  </div>
                </div>
                <div
                  v-if="player.academic_year"
                  class="sidearm-mm-player-card__about-stat flex flex-justify-between flex-align-center px-1 border-light-t"
                >
                  <div class="px-1">Class:</div>
                  <div class="px-1">{{ player.academic_year }}</div>
                </div>
                <div
                  v-if="player.position_short"
                  class="sidearm-mm-player-card__about-stat flex flex-justify-between flex-align-center px-1 border-light-t"
                >
                  <div class="px-1">Position:</div>
                  <div class="px-1">{{ player.position_short }}</div>
                </div>
              </div>
              <div
                class="sidearm-mm-player-card__charts flex flex-align-stretch"
              >
                <div
                  class="sidearm-mm-player-card__chart py-3 flex border-light-l flex-column flex-align-center flex-justify-center"
                >
                  <abbr
                    title="Field Goal Percentage"
                    class="mb-1 text-decoration-none border-none"
                    >FG%</abbr
                  >
                  <div class="sidearm-mm-player-card__chart-graph">
                    <circle-chart
                      :percentage="
                        parseFloat(player.cumestats.field_goal_percentage) * 100
                      "
                    />
                  </div>
                </div>
                <div
                  class="sidearm-mm-player-card__chart py-3 flex border-light-l flex-column flex-align-center flex-justify-center"
                >
                  <abbr
                    title="3 Point Percentage"
                    class="mb-1 text-decoration-none border-none"
                    >3PT%</abbr
                  >
                  <div class="sidearm-mm-player-card__chart-graph">
                    <circle-chart
                      :percentage="
                        parseFloat(
                          player.cumestats.three_point_goal_percentage
                        ) * 100
                      "
                    />
                  </div>
                </div>
                <div
                  class="sidearm-mm-player-card__chart py-3 flex border-light-l flex-column flex-align-center flex-justify-center"
                >
                  <abbr
                    title="Free Throw Percentage"
                    class="mb-1 text-decoration-none border-none"
                    >FT%</abbr
                  >
                  <div class="sidearm-mm-player-card__chart-graph">
                    <circle-chart
                      :percentage="
                        parseFloat(player.cumestats.free_throws_percentage) *
                          100
                      "
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="sidearm-mm-player-card__stats flex flex-align-stretch flex-justify-start flex-wrap"
            >
              <div
                class="sidearm-mm-player-card__stat flex flex-column flex-align-center flex-justify-center py-2 border-light-r border-light-b"
              >
                <abbr
                  title="Points"
                  class="text-uppercase text-decoration-none text-center border-none type-paragraph"
                  >Pts</abbr
                >

                <div class="type-hero-small text-center">
                  {{ player.cumestats.points_per_game }}
                </div>
              </div>
              <div
                class="sidearm-mm-player-card__stat flex flex-column flex-align-center flex-justify-center py-2 border-light-r border-light-b"
              >
                <abbr
                  title="Rebounds"
                  class="text-uppercase text-decoration-none text-center border-none type-paragraph"
                  >Reb</abbr
                >

                <div class="type-hero-small text-center">
                  {{ player.cumestats.rebounds_per_game }}
                </div>
              </div>
              <div
                class="sidearm-mm-player-card__stat flex flex-column flex-align-center flex-justify-center py-2 border-light-b"
              >
                <abbr
                  title="Assists"
                  class="text-uppercase text-decoration-none text-center border-none type-paragraph"
                  >Ast</abbr
                >

                <div class="type-hero-small text-center">
                  {{ player.cumestats.assists_per_game }}
                </div>
              </div>
              <div
                class="sidearm-mm-player-card__stat flex flex-column flex-align-center flex-justify-center py-2 border-light-r border-light-b"
              >
                <abbr
                  title="Blocks"
                  class="text-uppercase text-decoration-none text-center border-none type-paragraph"
                  >Blk</abbr
                >

                <div class="type-hero-small text-center">
                  {{ player.cumestats.blocks_per_game }}
                </div>
              </div>
              <div
                class="sidearm-mm-player-card__stat flex flex-column flex-align-center flex-justify-center py-2 border-light-r border-light-b"
              >
                <abbr
                  title="Steals"
                  class="text-uppercase text-decoration-none text-center border-none type-paragraph"
                  >Stl</abbr
                >

                <div class="type-hero-small text-center">
                  {{ player.cumestats.steals_per_game }}
                </div>
              </div>
              <div
                class="sidearm-mm-player-card__stat flex flex-column flex-align-center flex-justify-center py-2 border-light-b"
              >
                <abbr
                  title="Field Goal Percentage"
                  class="text-uppercase text-decoration-none text-center border-none type-paragraph"
                  >FG%</abbr
                >

                <div class="type-hero-small text-center">
                  {{
                    (
                      parseFloat(player.cumestats.field_goal_percentage) * 100
                    ).toFixed(0)
                  }}
                </div>
              </div>
            </div>
          </div>
          <a
            v-if="player_bio_url(player)"
            :href="player_bio_url(player)"
            target="_blank"
            class="sidearm-mm-player-card__bio-link sidearm-mm-btn --primary "
            >View Full Bio</a
          >
        </div>

        <div class="sidearm-mm-player-card__slot">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CircleChart from "@/components/CircleChart";

export default {
  components: {
    CircleChart
  },
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false
    },

    playerId: {
      type: Number,
      required: true,
      default: 0
    },

    player: {
      type: [Object, Boolean],
      required: true,
      default: false
    },

    teamId: {
      type: Number,
      required: true,
      default: 0
    }
  },

  data: () => ({
    //player: null,
    cumestats: null
  }),

  watch: {
    value(newVal) {
      if (!newVal) {
        //this.player = null;
      }
    }
  },

  methods: {
    close() {
      this.$emit("input", false);
    },

    get_player_data() {
      //this.player = null;
    },
    player_bio_url(player) {
      if (!player) {
        return null;
      }
      if (!player.is_opponent) {
        return "/roster.aspx?rp_id=" + player.rp_id;
      }
      if (player.team && player.team.website) {
        return `${player.team.website.replace(/\/+$/, "")}/roster.aspx?rp_id=${
          player.rp_id
        }`;
      }
      return null;
    }
  }
};
</script>

<style lang="scss" scoped>
.#{$prefix}-player-card {
  @include hide();
  opacity: 0;
  background-color: rgba($color-black, 0.8);
  transform: translateY(100%);
  transition: transform 0.4s, height 0s 0.4s, left 0s 0.4s, top 0s 0.5s,
    width 0s 0.4s;
  &.is-toggled {
    @include unhide();
    left: 0;
    height: 100%;
    opacity: 1;
    position: fixed;
    top: 0;
    transform: none;
    transition: transform 0.4s;
    width: 100%;
    z-index: 101;
  }

  &__close-btn {
    @include base-reset();

    font-size: 1.125rem;
    color: $color-white;
    padding: $spacer * 4;
  }

  &__container {
    z-index: 1;
    overflow: auto;
    flex: 1 0 auto;
  }
  &__container-inner {
    display: flex;
    align-items: center;
    -webkit-align-items: center;
  }

  &__player-container {
    bottom: 0;
    left: 0;
    position: absolute;
    margin-left: 12.5%;
    width: 37.5%;
    height: 100%;
  }

  &__player-container-title {
    display: none;
  }

  &__player-cutout {
    bottom: 0;
    right: 0;
    max-height: 100%;
    left: 50%;
    transform: translate(-50%);
    position: absolute;
  }

  &__stat-content {
    width: 37.5%;
    margin-left: 50%;
    height: 100%;
  }

  &__roster {
    position: relative;
  }
  &__roster-player {
    &::after {
      border-top: 1px dashed $stroke-on-light;
      content: "";
      display: block;
      height: 1px;
      width: $spacer * 4;
      transition: 0.3s;
    }
    &.active {
      .sidearm-mm-player-card__roster-player-toggle {
        border-color: $stroke-on-dark;
      }
      &::after {
        width: $spacer * 8;
        border-color: $stroke-on-dark;
      }
    }
  }

  &__roster-player-toggle {
    @include base-reset();

    border-radius: 50%;
    border: 1px dashed $stroke-on-light;
    height: 84px;
    padding: $spacer;
    width: 84px;
    transition: 0.3s;

    img {
      border-radius: 50%;
    }
  }

  &__about {
    @include flex-item(0 0 auto);
    width: 33.333%;
  }
  &__about-stat {
    @include flex-item(1 0 auto);
    height: 33.333%;
  }
  &__charts {
    @include flex-item(0 1 auto);
    width: 66.6667%;
  }
  &__chart {
    @include flex-item(0 1 auto);
    width: 33.3333%;
  }
  &__chart-graph {
    width: 100%;
    max-width: 60px;
  }
  &__stat {
    @include flex-item(1 0 auto);
    width: 33.333%;
  }
  &__bio-link {
    bottom: 0;
    right: 0;
    margin-top: $spacer * 4;
  }

  &__background {
    width: 62.5%;
    height: 100%;
    bottom: 0;
    left: 0;
    z-index: -1;
    position: absolute;
  }

  &__background-blur {
    bottom: 0;
    right: 0;
  }
  &__slot {
    height: 100%;
    width: 12.5%;
    padding-top: $spacer * 4;
  }
}

@media (max-width: #{$breakpoint-laptop}) {
  .sidearm-mm-player-card {
    &__player-container {
      margin-left: 0;
    }
    &__stat-content {
      width: 50%;
      margin-left: 37.5%;
    }
    &__roster-player {
      &::after {
        width: $spacer * 2;
      }
      &.active {
        &::after {
          width: $spacer * 2;
        }
      }
    }
  }
}

@media (max-width: #{$breakpoint-x-large}) {
  .sidearm-mm-player-card {
    &__slot {
      position: absolute;
      top: 0;
      left: 0;
      border-bottom: solid 1px #eaeaea;
      height: auto;
      padding-top: 0;
      width: 100%;
    }
    &__roster-player-toggle {
      width: 48px;
      height: 48px;
      padding: 6px;
    }
    &__container-inner {
      align-items: flex-end;
      -webkit-align-items: flex-end;
    }
    &__player-container-title {
      display: block;
      padding-top: $spacer * 9;
      margin-top: $spacer * 2;
    }
    &__player-container {
      position: relative;
      width: 33.333%;
      height: 100%;
    }
    &__player-cutout {
      position: relative;
      transform: none;
      left: 0;
    }
    &__stat-content {
      width: 66.6667%;
      margin: 0;
    }
    &__stat-content-title {
      display: none;
    }
  }
}

@media (max-width: #{$breakpoint-large}) {
  .sidearm-mm-player-card {
    &__close-btn {
      padding: $spacer * 2 0;
    }
    &__roster-player {
      &::after {
        width: $spacer * 1;
      }
      &.active {
        &::after {
          width: $spacer * 1;
        }
      }
    }
    &__container-inner {
      display: block;
    }
    &__player-container {
      width: 100%;
    }
    &__player-cutout {
      max-height: 60vh;
      display: block;
      margin: 0 auto;
    }
    &__stat-content {
      width: 100%;
    }
    &__about {
      width: 100%;
      border-bottom: solid 1px #eaeaea;
    }
    &__about-stat {
      width: 100%;
      padding: $spacer * 1.5 $spacer;
    }
    &__charts {
      width: 100%;
    }
    &__chart {
      &:first-child {
        border: none;
      }
    }
    &__bio-link {
      margin-top: 0;
      display: block;
      width: 100%;
      text-align: center;
    }
  }
}
</style>
